/**
 * 会员详细信息请求接口
 * @author 王振宇
 * @since 2022-05-05
 */
export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request,
    serviceForMock = _ref.serviceForMock,
    requestForMock = _ref.requestForMock,
    mock = _ref.mock,
    faker = _ref.faker,
    tools = _ref.tools;
  return {
    GET_MEMBERINFO_PAGE_LIST: function GET_MEMBERINFO_PAGE_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/memberInfo/getPageList',
        method: 'get',
        params: data
      });
    },
    GET_MEMBERINFO_LIST: function GET_MEMBERINFO_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/memberInfo/getList',
        method: 'get',
        params: data
      });
    },
    GET_MEMBERINFO_INFO: function GET_MEMBERINFO_INFO() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/memberInfo/info',
        method: 'get',
        params: data
      });
    },
    SAVE_MEMBERINFO: function SAVE_MEMBERINFO() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/memberInfo/save',
        method: 'post',
        data: data
      });
    },
    UPDATE_MEMBERINFO: function UPDATE_MEMBERINFO() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/memberInfo/update',
        method: 'put',
        data: data
      });
    },
    DELETE_MEMBERINFO: function DELETE_MEMBERINFO() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/memberInfo/delete',
        method: 'delete',
        data: data
      });
    },
    DELETE_BATCH_MEMBERINFO: function DELETE_BATCH_MEMBERINFO() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/memberInfo/deleteBatch',
        method: 'delete',
        data: data
      });
    }
  };
});